import { slideoutStore } from '@atomic-ui/slideout';
import { locations } from '@common-vue/locator/src/store';
import { modalOverlayStore } from '@atomic-ui/modalOverlay';
import virtualTryOnStore from '@common-vue/virtual-try-on-experience/src/store_modules/VTO';
import wishlistStore from '@common-vue/product-thumbnail/src/store_modules/wishlistManager/store';
import recommendationStore from '@common-vue/pros-collection/src/store_modules/store';
import traitsStore from '@common-vue/media-card-large/src/store_modules/traitsStore';
import outfittingStore from '@common-vue/outfitting/src/store/outfittingStore';
import productQuickviewStore from '@common-vue/product-quickview/src/store/productQuickviewStore';
import addToRegistryStore from '@common-vue/add-to-registry/src/store';
import googleAdStore from '@common-vue/site-monetization/src/modules/googleAds/store';
import sponsoredItemTopStore from '@common-vue/site-monetization/src/modules/sponsoredItemTop/store';
import productStore from './store_modules/productStore';
import productImagesCtaStore from './store_modules/productImagesCtaStore';
import slideout from './store_modules/slideout';
import reviewsStore from './store_modules/reviewsStore';
import availabilityStore from './store_modules/availabilityStore';
import availabilityBigTicketStore from './store_modules/availabilityBigTicketStore';
import extraStore from './store_modules/extraStore';

import {
  SET_PAGE_UTAG_DATA,
} from './types/setters';

export default {
  namespaced: true,
  modules: {
    slideoutStore,
    productStore,
    outfittingStore,
    productImagesCtaStore,
    productQuickviewStore,
    modalOverlayStore,
    slideout,
    reviewsStore,
    wishlistStore,
    availabilityStore,
    availabilityBigTicketStore,
    VTO: virtualTryOnStore,
    recommendationStore,
    locations,
    addToRegistryStore,
    googleAdStore,
    sponsoredItemTopStore,
    extraStore,
    traitsStore,
  },
  state() {
    return {};
  },
  getters: {},
  mutations: {
    /**
     *
     * @param {*} state
     * @param {*} pageUtagData
     */
    [SET_PAGE_UTAG_DATA](state, pageUtagData) {
      state.pageUtagData = pageUtagData;
    },
  },
  actions: {},
};
